import { api } from '@/lib/api';
import type { IApiResponse, IBridgeRepositoryProduct } from '@skystone/shared';

export const bridgeRepoProductApi = {
  getAll: async (): Promise<IBridgeRepositoryProduct[]> => {
    const result = await api.get<IApiResponse<IBridgeRepositoryProduct[]>>('/bridge-repository-product');
    return result.data;
  },
};
